import { render, staticRenderFns } from "./HotSpecialTopic.vue?vue&type=template&id=cd29daf8&scoped=true"
import script from "./HotSpecialTopic.vue?vue&type=script&lang=js"
export * from "./HotSpecialTopic.vue?vue&type=script&lang=js"
import style0 from "./HotSpecialTopic.vue?vue&type=style&index=0&id=cd29daf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd29daf8",
  null
  
)

export default component.exports